module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/Group 6-7a83fb41027b7e6e38f100a7fd321667.jpg";